import * as React from 'react';
import Icon from '../Icon';


var AccountIcon = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement(Icon, { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", className: "AccountIcon " + (AccountIcon || ''), onClick: onClick },
        React.createElement("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H30C31.1046 0 32 0.895431 32 2V30C32 31.1046 31.1046 32 30 32H2C0.895431 32 0 31.1046 0 30V2Z", fill: "#EBE8F1" }),
        React.createElement("path", { d: "M15.4444 13.7778V6H6V13.7778H15.4444Z", fill: "#EBE8F1" }),
        React.createElement("path", { d: "M26 26V18.2222H16.5555V26H26Z", fill: "#EBE8F1" }),
        React.createElement("path", { d: "M19.8889 6V13.7778H26V6H19.8889Z", fill: "#EBE8F1" }),
        React.createElement("path", { d: "M6 18.2222V26H12.1111V18.2222H6Z", fill: "#EBE8F1" }),
        React.createElement("path", { d: "M15.4444 13.7778V6H6V13.7778H15.4444Z", stroke: "#271158", strokeWidth: "2", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M26 26V18.2222H16.5555V26H26Z", stroke: "#271158", strokeWidth: "2", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M19.8889 6V13.7778H26V6H19.8889Z", stroke: "#271158", strokeWidth: "2", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M6 18.2222V26H12.1111V18.2222H6Z", stroke: "#271158", strokeWidth: "2", strokeLinejoin: "round" })));
};
export default React.memo(AccountIcon);
